import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  setIsBetaWorkstation,
  setLoginStatus,
} from "../../lib/store/reducers/applicationStateReducer";
import {
  finishSkuPutaway,
  updateBoxBarcode,
} from "../../lib/store/reducers/conveyorBoxReviewReducer";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import SwapBoxModal from "./SwapBoxModal/SwapBoxModal";
import ChangeWeightModal from "./ChangeWeightModal/ChangeWeightModal";
import SkuPutawayModal from "./SkuPutawayModal/SkuPutawayModal";
import styles from "./ControlApp.module.css";
import { PayloadWrapper } from "../../lib/store/types/PayloadWrapper";
import MainOverview from "./MainOverview/MainOverview";
import { getParamValue } from "../../utils/UtilMethods";
import { IConveyorBoxUI } from "../../lib/interfaces/ConveyorBox/IConveyorBox";
import {
  setIsSwapBoxModalOpen,
  setIsPartialDeliveryModalOpen,
  setIsChangeWeightModalOpen,
  controlAppStateSelector,
} from "../../lib/store/reducers/controlAppStateReducer";

import { ILoginInfo } from "../../lib/store/types/LoginStateTypes";
import { VIEW, LogAction } from "../../utils/Constants";
import Login from "../Login/Login";
import { OperatorInfoModel } from "../../lib/interfaces/Login/IOperatorInfoModel";
import { WorkstationInfoModel } from "../../lib/interfaces/Login/IWorkstationInfoModel";
import { setUser, setWorkstation } from "../../lib/store/reducers/loginInfoReducer";
import WorkstationEndpoints from "../../lib/workstation/WorkstationEndpoints";
import GlobalMessages from "./ResponseMessages/GlobalMessages";

const ControlApp = () => {
  const dispatch = useDispatch();
  const appState = useSelector(controlAppStateSelector);
  const loadingState = useSelector<any, any>((state) => state.loadingStateReducer);
  const conveyorBoxReview = useSelector<any, IConveyorBoxUI>(
    (state) => state.conveyorBoxReviewReducer
  );

  const loginInfo: any = useSelector<any>((state) => state.loginInfoReducer);
  const workstationID = getParamValue("ws");
  // login logic for new checkstation
  const loginHandler = async (operator: any) => {
    console.log(workstationID);
    console.log(operator);

    let operatorID = -1;
    let operatorName = "Okänd";
    if (typeof operator === "object") {
      operatorID = operator.operatorId;
      operatorName = operator.operatorName;
    } else {
      operatorID = operator;
    }

    WorkstationEndpoints.operatorLog(operatorID, workstationID, LogAction.LOGIN, "Operator logged in");

    dispatch(setUser(new OperatorInfoModel(operatorID, operatorName)));
    dispatch(setWorkstation(new WorkstationInfoModel(workstationID, -1, 20)));
    dispatch(setLoginStatus(new PayloadWrapper(true)));
  };

  const LogoutHandler = () => {

      if (loginInfo && loginInfo.operatorID > 0) {
      WorkstationEndpoints.operatorLog(loginInfo.operatorID, workstationID, LogAction.LOGOUT, "Operator logged out" );
    }
    dispatch(setUser(new OperatorInfoModel(-1, "Okänd")));
    dispatch(setWorkstation(new WorkstationInfoModel(-1, 0, -1)));
    dispatch(setLoginStatus(new PayloadWrapper(false)));
    dispatch(setIsBetaWorkstation(new PayloadWrapper(false)));
  };

  const reviewParam = getParamValue("review");
  const isReviewMode = (reviewParam && reviewParam === "true") || reviewParam === "1";

  const { items } = conveyorBoxReview;
  useEffect(() => {
    document.title = "Kontrollstation";
    return () => {
      document.title = "Packmaskin";
    }; // reset to Packmaskin on unmount.
  }, []);

  return loginInfo.operatorID && loginInfo.operatorID > 0 ? (
    <main className={styles["control-app"]}>
      <Header isReviewMode={isReviewMode} onLogout={LogoutHandler} />

        <GlobalMessages mode="WAREHOUSE" />
        {conveyorBoxReview.boxBarcode && <MainOverview isReviewMode={isReviewMode} />}
        <Footer />

      <SwapBoxModal
        isOpen={appState.isSwapBoxModalOpen}
        onClose={() => dispatch(setIsSwapBoxModalOpen(new PayloadWrapper(false)))}
        onTriggerBoxSwap={(currentBarcode, newBarcode, selectedBoxSize) => {
          dispatch(updateBoxBarcode({ currentBarcode, newBarcode, selectedBoxSize }));
        }}
        currentBoxBarcode={conveyorBoxReview.boxBarcode}
        isBoxSwapFinished={appState.isBoxSwapFinished}
        isPendingBoxSwap={loadingState.isPendingBoxSwap}
        isClosable={
          !appState.isForcedRxBagVerification || appState.isForcedRxBagVerificationFinished
        }
      />

      <ChangeWeightModal
        barcode={conveyorBoxReview.boxBarcode}
        items={items.active}
        isOpen={appState.isChangeWeightModalOpen}
        onClose={() => dispatch(setIsChangeWeightModalOpen(new PayloadWrapper(false)))}
      />

      <SkuPutawayModal
        items={items.active}
        isSelectionMode
        isForcedOpen={appState.isPartialDeliveryModalOpen}
        finishSkuPutaway={(items) => dispatch(finishSkuPutaway({ isCancelledItems: false, items }))}
        onClose={() => dispatch(setIsPartialDeliveryModalOpen(new PayloadWrapper(false)))}
      />
    </main>
  ) : (
    <Login
      loginCallback={(operator: ILoginInfo) => loginHandler(operator)}
      workstationID={getParamValue("ws")}
      loginView={VIEW.VARBERG}
    />
  );
};

export default ControlApp;
